<template>
  <div class="home_campus_job_area campus_recruiting_area">
    <div class="campus_job_block campus_recruiting_block clearfix">
      <div class="title">
        {{ recruitment.recruitment_name }}
      </div>
      <div class="date_area clearfix">
        <div class="date_block">
          <div class="data_title">
            活動報名日期：
          </div>
          <div class="date">
            {{ recruitment.enroll_start_date || new Date() | moment("YYYY/MM/DD") }} ～ {{ recruitment.enroll_end_date || new Date() | moment("YYYY/MM/DD") }}
          </div>
        </div>
      </div>
      <div class="decorative_line" />
      <ul class="info">
        <li v-if="recruitment.has_orientation">
          {{ recruitment.orientation_name }} {{ recruitment.orientation_start_date || new Date() | moment("YYYY/MM/DD") }} ~ {{ recruitment.orientation_end_date || new Date() | moment("YYYY/MM/DD") }}
        </li>
        <li v-if="recruitment.has_expo">
          {{ recruitment.expo_name }} {{ recruitment.expo_date || new Date() | moment("YYYY/MM/DD") }}
        </li>
      </ul>
      <div class="apply_btn">
        <router-link
          :to="`/campus-recruiting/${recruitment.recruitment_id}`"
        >
          活動詳情
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'CampusRecruitingIndexCard',
  props: {
    recruitment: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
